var _defs, _g, _path, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessagesBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    className: "messages-badge-icon",
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".messages-badge-icon .a{fill:#fff;stroke:#707070;opacity:0;}.messages-badge-icon .b{fill:#acb5c0;stroke:#acb5c0;stroke-width:0.6px;}.messages-badge-icon .c{fill:#44dec5;fill-rule:evenodd;}.messages-badge-icon .d{stroke:none;}.messages-badge-icon .e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.3,0H3.23A3.233,3.233,0,0,0,0,3.23V12.56a3.233,3.233,0,0,0,3.23,3.23h1L3.6,18.948a.359.359,0,0,0,.519.388l6.74-3.546H18.3a3.233,3.233,0,0,0,3.23-3.23V3.23A3.233,3.233,0,0,0,18.3,0Zm2.512,12.56A2.515,2.515,0,0,1,18.3,15.072H10.766a.358.358,0,0,0-.167.041L4.447,18.351,5.017,15.5a.359.359,0,0,0-.352-.431H3.23A2.515,2.515,0,0,1,.718,12.56V3.23A2.515,2.515,0,0,1,3.23.718H18.3A2.515,2.515,0,0,1,20.814,3.23Zm0,0",
    transform: "translate(3.234 4.295)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.851 2.412)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M32.4,6.4a3,3,0,1,0-3-3,3,3,0,0,0,3,3Z",
    transform: "translate(-29.4 -0.4)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesBadgeIcon);
export default __webpack_public_path__ + "static/media/messages-badge-icon.84295ae6853cb2fc4b0d4366ddd3dd8b.svg";
export { ForwardRef as ReactComponent };